import logoApidDoc from '../../assets/img/apidocs-logo.png'
import apidoc from '../../assets/img/apidocs-logo.png'
import maintenanceIcon from '../../assets/img/maintenance.svg'
import { Box, LinearProgress, Typography } from '@mui/material'

interface SplashScreenProps {
    dismiss: boolean,
    maintenance: boolean
}

export default function SplashScreen({ dismiss, maintenance }: SplashScreenProps) {
    return (
        <div className={`splash ${dismiss && 'dismiss'}`}>
            {maintenance ?
                <div className='d-flex w-50 m-auto'>
                    <img src={maintenanceIcon} alt={"En mantenimiento"} className='maintenance-logo' />
                    <img src={apidoc} className='maintenance-logo' />
                </div> : <img src={logoApidDoc} alt="logo-apidoc-splash" className='splash-logo' />}
            <div className='d-flex-center'>
                <Box sx={{ width: '33%', margin: 'auto' }}>
                    {maintenance && <Typography sx={{ textAlign: 'center' }}>Nos encontramos trabajando, disculpe las molestias.</Typography>}
                    <LinearProgress />
                </Box>
            </div>
        </div>
    )
}
